import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import compose from 'recompose/compose';
import { Field, Form, reduxForm } from 'redux-form';
import { propBool, propFunc } from '../../../../../helpers/custom-prop-types';
const FormUpdateMemo = ({ disabled, handleSubmit }) => (_jsx(Form, Object.assign({ onSubmit: () => { } }, { children: _jsx(Field, { component: 'textarea', name: 'memo', onBlur: handleSubmit, props: {
            disabled,
            maxLength: 500,
            placeholder: 'メモ',
        } }) })));
FormUpdateMemo.propTypes = {
    disabled: propBool().isRequired,
    handleSubmit: propFunc().isRequired,
};
// the name of redux-form must be dynamically assigned
const enhance = compose(reduxForm());
export default enhance(FormUpdateMemo);
